module.exports = __webpack_public_path__ + "fonts/ccf59c7.woff";